var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_47649)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8925 8.53167C20.431 9.10302 18.6259 10.6538 17.7233 12.776C17.6412 13.0208 17.5592 13.1841 17.4771 13.4289C17.3951 13.5922 17.3951 13.837 17.313 14.0003C17.231 14.2451 17.231 14.49 17.1489 14.6532C17.0669 15.0614 17.0669 15.4695 17.0669 15.9592C17.0669 18.0813 17.7233 19.877 18.9541 21.1829L19.0361 21.2646C20.431 22.8154 22.5643 23.7132 24.9438 23.7132C26.6668 23.7132 28.3899 23.3051 29.7847 22.4889C30.277 22.244 30.6052 21.7543 30.6052 21.1829C30.6052 20.3667 29.8668 19.6321 29.0463 19.6321C28.8001 19.6321 28.554 19.7138 28.3078 19.7954C27.4053 20.2851 26.2566 20.6116 25.354 20.6116C22.8104 20.6116 21.3335 19.0608 21.0874 17.1835H29.7027C31.1796 17.1835 32.0001 16.6122 32.0001 15.3878C32.0001 11.5516 29.0463 8.2868 24.6155 8.2868C24.0412 8.36843 23.4668 8.36843 22.8925 8.53167ZM21.1694 14.2451C21.1694 14.0003 21.2515 13.837 21.3335 13.6738C21.8258 12.5311 22.8104 11.47 24.6976 11.47C27.2412 11.47 28.2258 13.3473 28.3078 14.7349H21.0874C21.0874 14.49 21.0874 14.3268 21.1694 14.2451Z",
    fill: "url(#paint0_linear_47_47649)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94351 10.0011L6.15379 18.4897L3.69228 9.83785C3.44613 9.02164 2.78972 8.45029 1.88716 8.45029C0.820506 8.45029 0 9.2665 0 10.3276C0 10.4908 0 10.7357 0.0820506 10.8989L3.36407 21.5913C3.69228 22.734 4.75893 23.4686 5.98969 23.4686C7.22045 23.4686 8.20506 22.6524 8.53326 21.5913L11.1589 13.3476L13.7024 21.5913C14.0307 22.734 15.0973 23.4686 16.3281 23.4686C17.5588 23.4686 18.5434 22.6524 18.8716 21.5913L18.9537 21.1832V21.1016L21.087 14.0821L21.2511 13.5108L22.8101 8.45029C20.4306 9.02164 18.6255 10.5724 17.7229 12.6946C17.6409 12.9394 17.5588 13.1027 17.4768 13.3476L17.3127 13.9189L17.1486 14.5719L16.0819 18.4072L13.2922 9.91947C13.046 9.02164 12.1435 8.36867 11.1589 8.36867C10.0922 8.45029 9.18967 9.10326 8.94351 10.0011Z",
    fill: "url(#paint1_linear_47_47649)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_47649",
    x1: 18.6004,
    y1: 19.2271,
    x2: 27.6529,
    y2: 21.8848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0515278,
    stopColor: "#2F3A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3573,
    stopColor: "#36A9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    stopColor: "#66C5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66C5DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_47649",
    x1: 0.0215508,
    y1: 23.4731,
    x2: 22.8111,
    y2: 23.4731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36A9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3085,
    stopColor: "#3EADE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#52B8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66C5DB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_47649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompact);
export default __webpack_public_path__ + "static/media/compact.5937c0c8e5e3b20fe79dbed4eb3da23f.svg";
export { ForwardRef as ReactComponent };